import React, { useState } from 'react';
import { View, ScrollView, StyleSheet, Alert } from 'react-native';
import { TextInput, Button, Text, useTheme, HelperText, ActivityIndicator, Snackbar } from 'react-native-paper';
import { useAuth } from '../../../context/AuthContext';

const ChangePasswordScreen = ({ navigation }) => {
  const theme = useTheme();
  const { user } = useAuth();
  
  // Form state
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [showCurrentPassword, setShowCurrentPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  
  // UI state
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [snackbarVisible, setSnackbarVisible] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  
  const validateForm = () => {
    const newErrors = {};
    
    if (!currentPassword.trim()) {
      newErrors.currentPassword = 'Mevcut şifre alanı gereklidir';
    }
    
    if (!newPassword.trim()) {
      newErrors.newPassword = 'Yeni şifre alanı gereklidir';
    } else if (newPassword.length < 6) {
      newErrors.newPassword = 'Şifre en az 6 karakter olmalıdır ve bir özel karakter ile birer küçük, büyük harf içermelidir.';
    }
    
    if (!confirmPassword.trim()) {
      newErrors.confirmPassword = 'Şifre tekrar alanı gereklidir';
    } else if (newPassword !== confirmPassword) {
      newErrors.confirmPassword = 'Şifreler eşleşmiyor';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  
  const handleChangePassword = async () => {
    if (!validateForm()) return;
    
    setLoading(true);
    
    try {
      // AuthContext'te henüz şifre değiştirme fonksiyonu olmadığı için
      // simüle ediyoruz. Gerçek uygulamada API çağrısı yapılmalıdır.
      
      setTimeout(() => {
        setSnackbarMessage('Şifreniz başarıyla değiştirildi');
        setSnackbarVisible(true);
        
        // Formu temizle
        setCurrentPassword('');
        setNewPassword('');
        setConfirmPassword('');
        
        // Kısa bir süre bekleyip profil ekranına dön
        setTimeout(() => {
          navigation.goBack();
        }, 1500);
        
        setLoading(false);
      }, 1000);
      
    } catch (error) {
      console.error('Error changing password:', error);
      
      if (error.message === 'current-password-invalid') {
        setErrors({ currentPassword: 'Mevcut şifreniz yanlış' });
      } else {
        setSnackbarMessage('Şifre değiştirilirken bir hata oluştu');
        setSnackbarVisible(true);
      }
      setLoading(false);
    }
  };

  return (
    <ScrollView style={styles.container}>
      <View style={styles.formContainer}>
        <Text style={styles.headerText}>Şifre Değiştirme</Text>
        <Text style={styles.descriptionText}>
          Güvenliğiniz için, yeni şifrenizin en az 6 karakter olması ve büyük/küçük harfler, rakamlar ve özel karakterler içermesi önerilir.
        </Text>
        
        {/* Mevcut Şifre */}
        <TextInput
          label="Mevcut Şifre *"
          value={currentPassword}
          onChangeText={setCurrentPassword}
          mode="outlined"
          style={styles.input}
          error={!!errors.currentPassword}
          disabled={loading}
          secureTextEntry={!showCurrentPassword}
          outlineColor="rgb(125, 76, 236)"
          activeOutlineColor="rgb(125, 76, 236)"
          right={
            <TextInput.Icon 
              name={showCurrentPassword ? "eye-off" : "eye"} 
              onPress={() => setShowCurrentPassword(!showCurrentPassword)} 
              color="rgb(125, 76, 236)"
            />
          }
        />
        {errors.currentPassword && <HelperText type="error">{errors.currentPassword}</HelperText>}
        
        {/* Yeni Şifre */}
        <TextInput
          label="Yeni Şifre *"
          value={newPassword}
          onChangeText={setNewPassword}
          mode="outlined"
          style={styles.input}
          error={!!errors.newPassword}
          disabled={loading}
          secureTextEntry={!showNewPassword}
          outlineColor="rgb(125, 76, 236)"
          activeOutlineColor="rgb(125, 76, 236)"
          right={
            <TextInput.Icon 
              name={showNewPassword ? "eye-off" : "eye"} 
              onPress={() => setShowNewPassword(!showNewPassword)} 
              color="rgb(125, 76, 236)"
            />
          }
        />
        {errors.newPassword && <HelperText type="error">{errors.newPassword}</HelperText>}
        
        {/* Şifre Tekrarı */}
        <TextInput
          label="Şifre Tekrarı *"
          value={confirmPassword}
          onChangeText={setConfirmPassword}
          mode="outlined"
          style={styles.input}
          error={!!errors.confirmPassword}
          disabled={loading}
          secureTextEntry={!showConfirmPassword}
          outlineColor="rgb(125, 76, 236)"
          activeOutlineColor="rgb(125, 76, 236)"
          right={
            <TextInput.Icon 
              name={showConfirmPassword ? "eye-off" : "eye"} 
              onPress={() => setShowConfirmPassword(!showConfirmPassword)} 
              color="rgb(125, 76, 236)"
            />
          }
        />
        {errors.confirmPassword && <HelperText type="error">{errors.confirmPassword}</HelperText>}
        
        {/* Not */}
        <Text style={styles.noteText}>
          * işaretli alanların doldurulması zorunludur.
        </Text>
        
        {/* Kaydet Butonu */}
        <Button
          mode="contained"
          onPress={handleChangePassword}
          style={styles.saveButton}
          disabled={loading}
          labelStyle={{color: 'white', fontWeight: 'bold'}}
        >
          {loading ? (
            <ActivityIndicator color="white" size="small" />
          ) : (
            <Text style={{color: 'white'}}>Şifreyi Değiştir</Text>
          )}
        </Button>
        
        {/* İptal Butonu */}
        <Button
          mode="outlined"
          onPress={() => navigation.goBack()}
          style={styles.cancelButton}
          disabled={loading}
          textColor="rgb(125, 76, 236)"
        >
          İptal
        </Button>
      </View>
      
      <Snackbar
        visible={snackbarVisible}
        onDismiss={() => setSnackbarVisible(false)}
        duration={3000}
        style={{backgroundColor: 'rgb(125, 76, 236)'}}
        theme={{colors: {surface: '#fff'}}}
        action={{
          label: 'Tamam',
          onPress: () => setSnackbarVisible(false),
          color: '#fff'
        }}
      >
        {snackbarMessage}
      </Snackbar>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'rgb(232, 162, 249)',
  },
  formContainer: {
    padding: 16,
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    borderRadius: 8,
    margin: 8,
  },
  headerText: {
    fontSize: 22,
    fontWeight: 'bold',
    marginBottom: 12,
    color: 'rgb(125, 76, 236)',
  },
  descriptionText: {
    color: 'rgb(90, 50, 180)',
    marginBottom: 20,
    lineHeight: 20,
  },
  input: {
    marginBottom: 12,
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
  },
  noteText: {
    color: 'rgb(125, 76, 236)',
    fontSize: 12,
    marginBottom: 16,
    fontStyle: 'italic',
    fontWeight: 'bold',
  },
  saveButton: {
    marginTop: 16,
    paddingVertical: 8,
    backgroundColor: 'rgb(125, 76, 236)',
  },
  cancelButton: {
    marginTop: 12,
    paddingVertical: 8,
    borderColor: 'rgb(125, 76, 236)',
  },
});

export default ChangePasswordScreen;
